import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.sub-tasks')
  .factory('$subTasksTemplates', subTasksTemplatesObjectFactory);

/* @ngInject */
function subTasksTemplatesObjectFactory($bringozFactory: $bringozFactory,
                                        SubTasksTemplatesAPI: BringozApi,
                                        SubTasksTemplates_DS: DataStoreConfig) {
  function $subTasksTemplates(id: string) {
    return $bringozFactory(id, SubTasksTemplatesAPI, SubTasksTemplates_DS)
  }

  return $subTasksTemplates
}
